import { render, staticRenderFns } from "./bigScreen.vue?vue&type=template&id=55f3cb18&scoped=true&"
import script from "./bigScreen.vue?vue&type=script&lang=js&"
export * from "./bigScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f3cb18",
  null
  
)

export default component.exports